import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  PageHeader,
  Row,
  Select,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import { CSVLink } from "react-csv";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { GET, UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import { todayDate } from "../functions/dateFunctions";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { RangePicker } = DatePicker;

const { Option } = Select;

class GloceryArticle extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    chef: [],
    chef_selected: null,
    selected_date: todayDate(),
    start: null,
    end: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false,
    driver_around: [],
    openModal: false,
    ride_selected: null,
    show: "all",
    rate: null,
    rate_view: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: "glocery-item/get-all",
      data: null,
      token: token
    };

    const request_details_partner = {
      type: GET,
      url: service_api,
      route: "glocery-partner/get-all",
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const response_chef = await MakeRequestAsync(request_details_partner);

      this.setState({
        load: false,
        chef: decryptSingleData(response_chef?.data?.glocery_partner),
        data: decryptSingleData(response?.data?.glocery_item)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item-admin/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleVisible = async (id, status) => {
    const data = {
      visible: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item-admin/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleDelete = async (id, status) => {
    const data = {
      deleted: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: "glocery-item/update-glocery-item-admin/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id")
      },
      {
        title: "Image",
        dataIndex: "pic",
        render: (text) => (
          <a href={text} target="_blank">
            <img
              src={text}
              style={{
                width: 50,
                height: 50,
                objectFit: "contain"
              }}
              alt={"food-img"}
            />
          </a>
        )
      },
      {
        title: "Article",
        dataIndex: "name",
        render: (text) => <span>{text}</span>
      },
      {
        title: "Autres informations",
        dataIndex: "details",
        render: (text, record) => (
          <Tag color="volcano">
            <span>Coût: ${record?.cost}</span>
            <br />
            <span>Unité de mesure: {record?.weight_type}</span>
            <br />
            <span>Poids: {record?.weight}</span>
            <br />
          </Tag>
        )
      },
      {
        title: "Description",
        dataIndex: "description",
        width: "20%",
        render: (text) => (
          <Tag color={"purple"}>
            <span>{text}</span>
          </Tag>
        )
      },
      {
        title: "Supprimer",
        dataIndex: "deleted",
        render: (text) => (
          <Tag color={text === false ? "green" : "volcano"}>
            <b>
              {text === true && "Supprimer"}
              {text === false && "Non"}
            </b>
          </Tag>
        )
      },
      {
        title: "Visible",
        dataIndex: "visible",
        render: (text) => (
          <Tag color={text === false ? "volcano" : "green"}>
            <b>
              {text === true && "Visible"}
              {text === false && "Invisible"}
            </b>
          </Tag>
        )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag color={text === false ? "volcano" : "green"}>
            <b>
              {text === true && "Actif"}
              {text === false && "inactif"}
            </b>
          </Tag>
        )
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        {record.visible === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, true)}>
              Rendre visible
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleVisible(record._id, false)}>
              Rendre invisible
            </Link>
          </Menu.Item>
        )}

        {record.status === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Activer
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Desactiver
            </Link>
          </Menu.Item>
        )}

        {record.deleted === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleDelete(record._id, true)}>
              Supprimer
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleDelete(record._id, false)}>
              Restaurer
            </Link>
          </Menu.Item>
        )}
      </Menu>
    );

    const { load, data, start, end, chef, chef_selected } = this.state;
    return (
      <>
        <PageHeader
          title="Articles"
          tags={<Tag color="blue">Liste des articles</Tag>}
          subTitle=""
          extra={[
            <RangePicker
              showTime
              onChange={(data) => {
                logger.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null && end === null) {
                    return item?.glocery_partner === chef_selected;
                  }
                  return (
                    item?.glocery_partner === chef_selected &&
                    item.createdAt >= start &&
                    item.createdAt <= end
                  );
                })?.length
              }
            />
          </Row>
          <Row gutter={16}>
            {!load && (
              <>
                <Col span={4}>
                  <Form.Item
                    label="Selectionner un partenaire"
                    rules={[
                      {
                        required: true,
                        role: "selectionner un partenaire"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      onClear={() => {
                        this.setState({ chef_selected: null });
                      }}
                      style={{ width: "100%" }}
                      placeholder="Selectionner un partenaire"
                      defaultValue={chef_selected}
                      onChange={(data) => {
                        return this.setState({ chef_selected: data });
                      }}
                    >
                      {chef?.map((item) => (
                        <Option key={item?._id}>
                          <span>{item?.company_name}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          <Row
            style={{
              marginTop: 20
            }}
          >
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col span={24}>
                <Table
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null && end === null) {
                      return item?.glocery_partner === chef_selected;
                    }
                    return (
                      item?.glocery_partner === chef_selected &&
                      item.createdAt >= start &&
                      item.createdAt <= end
                    );
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchStoreToProps
)(GloceryArticle);
